

import {
    Grid,
    Card,
    Box,
    Typography,
    Button,
    useMediaQuery,
} from "@material-ui/core";
import React from "react";
import useStyles from "./useStyles";
import { useTranslation } from "react-i18next";

interface FileAlreadyUploadedProps {
    // Callback para remover o arquivo que foi carregado no container
    handleRequestToDeleteCurrentFile: () => void;
    // Callback que muda o estado do componente manager e atribui 'changeCurrentFile' para true
    handleChangeCurrentUploadedFile: () => void;
    // Verifica se tela é de celular
    cellphoneScreen?: boolean;
    // URL da imagem no container
    previewFileUrl?: string;
    // Status em que o componente se encontra
    uploadFileManagerStatus?:
        | "removingFile"
        | "updatingFile"
        | "notChangedFile";
    imgHeight?: string;
    imgWidth?: string;
    uploadTitle?: string;
}

const FileAlreadyUploaded: React.FC<FileAlreadyUploadedProps> = ({
    handleRequestToDeleteCurrentFile,
    handleChangeCurrentUploadedFile,
    cellphoneScreen,
    previewFileUrl,
    uploadFileManagerStatus,
    imgHeight,
    imgWidth,
    uploadTitle,
}) => {
    const { t } = useTranslation(["FileUpload"]);
    const {
        signatureTitle,
        containerImage,
        responsiveImg,
        buttonsSignature,
        warningBox,
        signatureButtons,
    } = useStyles();

    return (
        <Grid container spacing={2} alignItems={"center"} justify="center">
            <Grid item md={6} sm={12} xs={12}>
                <Card elevation={!cellphoneScreen ? 1 : 0}>
                    <Box>
                        <Typography
                            className={signatureTitle}
                            color={"textSecondary"}
                        >
                            {uploadTitle}
                        </Typography>
                        {uploadFileManagerStatus === "removingFile" ? (
                            <div className={warningBox}>
                                <Typography color="textSecondary">
                                    {t("confirm_exclude")}
                                </Typography>
                            </div>
                        ) : (
                            <div>
                                <Box
                                    className={containerImage}
                                    paddingX={!cellphoneScreen ? 12 : 0}
                                >
                                    <img
                                        src={previewFileUrl}
                                        width={imgWidth}
                                        height={imgHeight}
                                        className={responsiveImg}
                                        alt="Aquivo"
                                    />
                                </Box>
                                <div className={buttonsSignature}>
                                    <Button
                                        className={signatureButtons}
                                        onClick={
                                            handleRequestToDeleteCurrentFile
                                        }
                                    >
                                        <Typography color="error">
                                            {t("exclude")}
                                        </Typography>
                                    </Button>
                                    <Button
                                        className={signatureButtons}
                                        onClick={
                                            handleChangeCurrentUploadedFile
                                        }
                                    >
                                        <Typography color="primary">
                                            {t("send_another")}
                                        </Typography>
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};
export default FileAlreadyUploaded;
